import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const FuneralTabMobile = ({ selectedHall }) => {
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;


    const toggleAccordion = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    const handleHallSelection = (hallName) => {
        setIsAccordionOpen(false);
        // Navigate to the corresponding mobile sale page
        switch (hallName) {
            case '일반 장례절차':
                navigate('/general-funeral-procedures');
                break;
            case '종교별 장례절차':
                navigate('/funeral-information-religious');
                break;
            case '장례방법':
                navigate('/funeral-methods');
                break;
            case '기타':
                navigate('/funeral-information-other');
                break;
            default:
                break;
        }
    };

    return (
        <div>
            {/* First Accordion - Hall Selection */}
            <div className="sky-hall-special-room-mobile-accordion">
                <div
                    className="sky-hall-special-room-mobile-accordion-header"
                    onClick={toggleAccordion}
                    style={{
                        backgroundImage: 'url(/images mobile directions/36_765.svg)',
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                    <h3>{selectedHall}</h3>
                    <img
                        src="/images mobile directions/7202ea909cb877a6a9c4abd27098600d577ca10d.png"
                        alt="Toggle"
                        className={`sky-hall-special-room-mobile-accordion-toggle ${isAccordionOpen ? 'open' : ''}`}
                    />
                </div>

                {/* First Accordion Dropdown Content */}
                {isAccordionOpen && (
                    <div className="sky-hall-special-room-mobile-accordion-content">
                        <div className="sky-hall-special-room-mobile-hall-grid">
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/general-funeral-procedures' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('일반 장례절차')}
                            >
                                일반 장례절차

                            </div>
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/funeral-information-religious' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('종교별 장례절차')}
                            >
                                종교별 장례절차

                            </div>
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/funeral-methods' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('장례방법')}
                            >
                                장례방법
                            </div>
                            <div
                                className={`sky-hall-special-room-mobile-hall-option ${pathname === '/funeral-information-other' ? 'sky-hall-special-room-mobile-hall-option-active' : ''}`}
                                onClick={() => handleHallSelection('기타')}
                            >
                                기타
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FuneralTabMobile;

